import React, {
    useState, useEffect
} from 'react'
import axios from 'axios'
import Title, { TitleTag } from '../../../../Components/Atoms/Title'
import InputSelect, { InputSelectType } from '../../../../Components/Atoms/InputSelect'
import TextField from "../../../../Components/Atoms/TextField"
// Mol

// Sass
import '../../../../Sass/includes/Components/modules/C13.sass'
import '../../../../Sass/includes/Components/modules/c13.css'

const SITE_KEY = "6Lf6rTYpAAAAAPjW2pveZDHGOyx5b4oZxNAl8etm";

const C13PeopleOrgSuccess = (props) => {
    const {
        // ciudadName,
        telefono,
        idSolicitud,
        Configuracion,
        // Producto,
        nombres,
        idDocumento,
        numDocumento,
    } = props
    let urlReturn = localStorage.getItem('url_accordion') ? localStorage.getItem('url_accordion') : "/personas/"
    return (
        <div className="c13Box">
            <div className='c13Form'>
                <p className='c13FormInfoTitle'>
                    <i className='ico-check-circle'></i>
                    {Configuracion.titulo_RESUMEN_SOLICITUD}
                </p>
                <div className='c13FormInfo'>
                    <p className='c13FormInfoSub'>
                        N&uacute;mero de solicitud: {idSolicitud}
                    </p>
                    <p className='c13FormInfoDet'>
                        {Configuracion.subtitulo_RESUMEN_SOLICITUD}
                    </p>
                </div>
                <div className='c13FormInfo'>
                    <p className='c13FormInfoSub'>
                        Nombre:
                    </p>
                    <p className='c13FormInfoDet'>
                        {nombres}
                    </p>
                </div>
                <div className='c13FormInfo'>
                    <p className='c13FormInfoSub'>
                        N&uacute;mero m&oacute;vil:
                    </p>
                    <p className='c13FormInfoDet'>
                        {telefono}
                    </p>
                </div>
                <div className='c13FormInfo'>
                    <p className='c13FormInfoSub'>
                        Tipo de documento:
                    </p>
                    <p className='c13FormInfoDet'>
                        {idDocumento.split("|")[1]}
                    </p>
                </div>
                <div className='c13FormInfo'>
                    <p className='c13FormInfoSub'>
                        N&uacute;mero de documento:
                    </p>
                    <p className='c13FormInfoDet'>
                        {idDocumento.split("|")[0]}{numDocumento}
                    </p>
                </div>
                <div className='c13FormActions'>
                    <a className="btn btnPrimario" href={urlReturn}><span>Regresar</span></a>
                </div>
            </div>
        </div>
    )
}

const C13PeopleOrgForm = React.memo((props) => {

    const {
        onSubmit,
        errors,
        // dataCiudades,
        // ciudad,
        // setCiudad,
        // setCiudadName,
        telefono,

        nombres,
        setNombres,
        idDocumento,
        setIdDocumento,
        numDocumento,
        autorizacion,
        setAutorizacion,
        setNumberValid,
        setNumberValidDocument,
        // setIdProducto,
        // idProducto,
        Configuracion,
        // dataProducto,
        disabledContinua
    } = props

    // const isArray = Array.isArray(dataProducto)
    return (
        <div className="c13Box">
            <form className="c13Form" onSubmit={onSubmit}>
                <div className="c13FormDesc">
                    <h1>{Configuracion.titulo_FORMULARIO}</h1>
                    <p>{Configuracion.subtitulo_FORMULARIO}</p>
                </div>
                <div className="phoneFields">
                    <label htmlFor="">* Nombre</label>

                    <fieldset className="">
                        <div className="inputPhone">
                            {/* <span className="phoneCode">+53</span> */}
                            <TextField
                                placeholder='Nombre y Apellido'
                                className='inputField'
                                maxLength='100'
                                name='nombres'
                                value={nombres}
                                onChange={e => setNombres(e.target.value)}
                            >

                            </TextField>
                        </div>
                    </fieldset>
                </div>
                {errors?.nombres?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.nombres?.message}
                            </p>
                        </div>
                    </div>
                }
                <div className="phoneFields">
                    <label htmlFor="">* N&uacute;mero m&oacute;vil</label>

                    <fieldset className="">
                        <div className="inputPhone">
                            {/* <span className="phoneCode">+53</span> */}
                            <TextField
                                placeholder='N&uacute;mero fijo o celular'
                                className='inputField'
                                maxLength='10'
                                name='phoneNumber'
                                value={telefono}
                                onChange={e => setNumberValid(e.target.value)}
                            >

                            </TextField>
                        </div>
                    </fieldset>
                </div>
                {errors?.telefono?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.telefono?.message}
                            </p>
                        </div>
                    </div>
                }
                <fieldset>
                    <label htmlFor="">* Tipo de documento</label>

                    <span className="select">
                        <select value={idDocumento} onChange={e => setIdDocumento(e.target.value)}>
                            <option value="-1" disabled>Selecciona</option>
                            <option value="CC*|Cédula de ciudadanía">C&eacute;dula de ciudadan&iacute;a</option>
                            <option value="CE*|Cédula de extranjería">C&eacute;dula de extranjer&iacute;a</option>
                            <option value="NIT*|NIT">NIT</option>
                        </select>
                    </span>
                </fieldset>
                {errors?.idDocumento?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.idDocumento?.message}
                            </p>
                        </div>
                    </div>
                }
                {/* {
                    localStorage?.getItem('hide_product_promo') !== "true" &&
                    <fieldset>
                        <label htmlFor="">* Tipo de documento</label>

                        <span className="select">
                            <select disabled={!isArray} value={idProducto} onChange={e => setIdProducto(e.target.value)}>
                                <option value="-1" disabled>Selecciona</option>
                                {!isArray &&
                                    <option key={dataProducto.fi_id_producto} value={dataProducto.fi_id_producto} disabled>
                                        {dataProducto.fc_descripcion}
                                    </option>
                                }
                                {isArray &&
                                    dataProducto?.map(item => (
                                        <option key={item.fi_id_producto} value={item.fi_id_producto}>
                                            {item.fc_descripcion}
                                        </option>
                                    ))
                                }
                            </select>
                        </span>
                    </fieldset>
                }
                {errors?.producto?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.producto?.message}
                            </p>
                        </div>
                    </div>
                } */}
                <div className="phoneFields">
                    <label htmlFor="">* N&uacute;mero de documento</label>

                    <fieldset className="">
                        <div className="inputPhone">
                            <TextField
                                placeholder='00 000 000'
                                className='inputField'
                                maxLength='12'
                                name='numDocumento'
                                value={numDocumento}
                                onChange={e => setNumberValidDocument(e.target.value)}
                            >

                            </TextField>
                        </div>
                    </fieldset>
                </div>
                {errors?.numDocumento?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.numDocumento?.message}
                            </p>
                        </div>
                    </div>
                }
                <div className="c13FormTerms">
                    <label htmlFor="">*Campos obligatorios</label>
                </div>
                <div className="c13FormTerms">
                    <InputSelect
                        type={InputSelectType.CHECKBOX}
                        name='auth'
                        className=''
                        checked={autorizacion}
                        onChange={e => setAutorizacion(e.target.checked)}
                    >
                        <a href={Configuracion.link_DESTINO_AUTORIZO} target="_blank" rel="noopener noreferrer">{Configuracion.texto_AUTORIZO}</a>
                    </InputSelect>
                </div>
                {errors?.autorizacion?.message &&
                    <div className="c13Alerts" >
                        <div className="notification error">
                            <p>
                                {errors?.autorizacion?.message}
                            </p>
                        </div>
                    </div>
                }
                <div className="c13FormActions">

                    <button className={`btn btnPrimario ${disabledContinua ? 'disabled' : ''}`} disabled={disabledContinua} onClick={()=>{console.log("click")}} type='submit'>
                        <i className="ico.ico-phone" />
                        <span>
                            {disabledContinua ? "Enviando..." : "Continuar"}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    )
})
function C13PeopleOrg(props) {
    // const {} = props

    const [success, setSuccess] = useState(false)
    const [errors, setErrors] = useState({})
    const [ciudadName, setCiudadName] = useState('')
    const [idProducto, setIdProducto] = useState('-1')
    const [idPlan, setIdPlan] = useState(0)
    const [dataPlan, setDataPlan] = useState({})
    const [idSolicitud, setIdSolicitud] = useState('')
    const [mensajeSolicitud, setMensajeSolicitud] = useState('')
    const [value_promo, setValue_promo] = useState('')
    const [idFormulario, setIdFormulario] = useState(0)
    const [dataCiudades, setDataCiudades] = useState([])
    const [dataProducto, setDataProducto] = useState({})
    const [dataConfiguracion, setDataConfiguracion] = useState({})
    const [disabledContinua, setDisabledContinua] = useState(false)
    const [nombres, setNombres] = useState('')
    const [apellidos, setApellidos] = useState('')
    const [cedula, setCedula] = useState('')
    const [ciudad, setCiudad] = useState('1')
    // const [email, setEmail] = useState('')
    const [tipo_telefono, setTipo_telefono] = useState(null)
    const [telefono, setTelefono] = useState('')

    const [idDocumento, setIdDocumento] = useState('-1')
    const [numDocumento, setNumDocumento] = useState('')

    const [extension, setExtension] = useState('')
    const [autorizacion, setAutorizacion] = useState(false)
    const [glid, setGlid] = useState('')
    const [utm_source, setUtm_source] = useState('')
    const [utm_campaign, setUtm_campaign] = useState('')
    const [utm_medium, setUtm_medium] = useState('')
    const [queu_promo, setQueu_promo] = useState('')
    const [referencia_producto, setReferencia_producto] = useState('')
    const [canal_trafico, setCanal_trafico] = useState('')
    const [resumen_plan, setResumen_plan] = useState('')
    const [ruta_imagen, setRuta_imagen] = useState('')
    const [urlServicioWeb, setUrlServicioWeb] = useState(localStorage.getItem('url_servicio_web'))
    const [idStatus, setIdStatus] = useState(localStorage.getItem('id_status'))
    const [idFamilia, setIdFamilia] = useState(localStorage.getItem('id_familia'))
    const [referenciaProductoC, setReferenciaProductoC] = useState(localStorage.getItem('referencia_producto'))
    const [rutaImagenWcbk, setRutaImagenWcbk] = useState(localStorage.getItem('ruta_imagen_wcbk'))

    const [dataPromocion, setDataPromocion] = useState({})

    const getValuesDefault = async () => {
        if (urlServicioWeb === '') {
            setUrlServicioWeb(localStorage.getItem('url_servicio_web'))
        }
        if (idStatus === '') {
            setIdStatus(localStorage.getItem('id_status'))
        }
        if (idFamilia === '') {
            setIdFamilia(localStorage.getItem('id_familia'))
        }
        if (referenciaProductoC === '') {
            setReferenciaProductoC(localStorage.getItem('referencia_producto'))
        }
        if (rutaImagenWcbk === '') {
            setRutaImagenWcbk(localStorage.getItem('ruta_imagen_wcbk'))
        }

    }

    async function getCiudades() {
        console.log("dataCiudades********************************+")
        let url_servicio_web = urlServicioWeb
        //let url_servicio_web = 'https://backoffice-ng.amx-dev.clarodigital.net/api/CO_MS_BE_CRN_PLANES_POSTPAGO'
        let id_status = idStatus
        //let id_familia = 'SHO'
        const configCiudades = {
            method: 'POST',
            url: url_servicio_web + "obtenerCiudades",
            data: { fi_estatus: id_status },
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCiudades)
        console.log("response- getCiudades------------------------->", response);
        setDataCiudades(response.data)
    }

    async function getProducto(idProducto) {
        // console.log("dataProducto********************************+", idProducto)
        // let url_servicio_web = urlServicioWeb
        // //let url_servicio_web = 'https://backoffice-ng.amx-dev.clarodigital.net/api/CO_MS_BE_CRN_PLANES_POSTPAGO'
        // let id_status = idStatus
        // let id_familia = idFamilia
        // const url = url_servicio_web + `obtenerProducto?status=${id_status}&idFamilia=${id_familia}${idProducto === null ? '' : `&idProducto=${idProducto}`}`
        // const configCiudades = {
        //     method: 'GET',
        //     url: url,
        //     data: {},
        //     headers: {
        //         'Accept': "application/json",
        //         'Content-Type': "application/json"
        //     },
        // };
        // let response = await axios(configCiudades)
        // console.log("response- getProducto------------------------->", response);
        // if (response?.data?.length > 0) {

        //     setDataProducto(idProducto === null ? response.data : response.data[0])
        //     setIdProducto(idProducto === null ? '-1' : response.data[0].fi_id_producto.toString())
        // } else {
        //     window.location = "https://www.claro.com.co/personas/redirect"
        // }
        setDataProducto({})
        setIdProducto("-1")

    }

    async function getConfiguracion() {
        console.log("dataConfiguracion********************************+")
        let url_servicio_web = urlServicioWeb
        let id_status = idStatus
        const configConfiguracion = {
            method: 'GET',
            url: url_servicio_web + "obtenerConfiguracion?status=" + id_status,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configConfiguracion)
        console.log("response- getConfiguracion------------------------->", response);
        setDataConfiguracion(response.data)
    }

    // async function getPlan() {
    //     console.log("dataPlan********************************+")
    //     let url_servicio_web = localStorage.getItem('url_servicio_web_plan')
    //     const configPlan = {
    //         method: 'POST',
    //         url: url_servicio_web + "obtienePlanes",
    //         data: {id:idPlan},
    //         headers: {
    //             'Accept': "application/json",
    //             'Content-Type': "application/json"
    //         },
    //     };
    //     let response = await axios(configPlan)
    //     console.log("response- getPlan------------------------->", response);
    //     setDataPlan(response?.data?.[0])

    // }

    async function getInfoPlan(id_plan) {
        let resumen_planVal = "";

        if (id_plan !== null && id_plan !== 0) {
            // setIdPlan(idPlan)
            console.log("setIdPlan********************************+", id_plan)
            console.log("dataInfoPlan********************************+")

            let url_servicio_web = urlServicioWeb
            const configPlan = {
                method: 'GET',
                url: url_servicio_web + "obtenerInfoPlan?id_plan=" + id_plan,
                // data: {id:idPlan},
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json"
                },
            };
            let response = await axios(configPlan)
            console.log("response- getPlan------------------------->", response, response?.data?.[0]);
            await setDataPlan(response?.data?.[0])

            response?.data?.[0]?.caracteristicas.map((item, index) => (
                resumen_planVal += item?.fc_TITULO.replace(':', '') + ":" + item?.fc_VALOR + "*"
            ))
            resumen_planVal = resumen_planVal.replace(/\*$/, "")
            console.log("resumen_planVal", resumen_planVal)
            await setResumen_plan(resumen_planVal);
        }
    }

    async function getValuesURL() {
        console.log("dataValuesURL********************************+")
        const queryString = window.location.search;
        const referencia_productoC = referenciaProductoC
        setRuta_imagen(rutaImagenWcbk)

        // setResumen_plan('')
        setExtension('')
        // setEmail('')
        setCedula('')
        setApellidos('')
        setNombres('')


        const urlParams = new URLSearchParams(queryString);
        getProducto(urlParams.get('prod'))
        getInfoPlan(urlParams.get("planId"))
        let formIdType = urlParams.get("formId") === null || !urlParams.get('formId') ? 1 : urlParams.get('formId')
        if (urlParams.get("formId") !== null && urlParams.get("formId") !== "") {
            if (isNaN(urlParams.get("formId"))) {
                // console.log("urlParams.get(formId) isNaN", urlParams.get("formId"))
                formIdType = 1
            }
        }
        // setIdFormulario(urlParams.get("formId") === undefined || !urlParams.get('formId') ? 1 : urlParams.get('formId'))
        setIdFormulario(formIdType)
        setIdPlan(urlParams.get('planId'))
        setValue_promo(urlParams.get("promo"))
        const value_promo = urlParams.get("promo");
        const value_formId = urlParams.get("formId");
        setReferencia_producto(referencia_productoC ? referencia_productoC : "")
        const value_Glid = urlParams.get("gclid")
        const value_Utm_source = urlParams.get("utm_source")
        const value_Utm_campaing = urlParams.get("utm_campaign")
        const value_Utm_medium = urlParams.get("utm_medium")
        setGlid(value_Glid)
        setUtm_source(value_Utm_source)
        setUtm_campaign(value_Utm_campaing)
        setUtm_medium(value_Utm_medium)


        const fuente = urlParams.get("fuente");
        const medio = urlParams.get("medio");
        const campaign = urlParams.get("campaign");

        if (fuente !== undefined && fuente !== null) {
            setUtm_source(fuente);
        }
        if (medio !== undefined && medio !== null) {
            setUtm_medium(medio);
        }
        if (campaign !== undefined && campaign !== null) {
            setUtm_campaign(campaign);
        }

        const pauta = "pauta";
        const organico = "organico";

        var canal_traf = urlParams.get("canal_trafico");

        if (canal_traf !== null) {
            setCanal_trafico(canal_traf)
        }
        else {
            if ((value_Utm_source !== null && value_Utm_campaing !== null && value_Utm_medium !== null) || (value_Glid !== null)) {
                setCanal_trafico(pauta);
            }
        }

        if (value_Utm_source === null && value_Utm_campaing === null && value_Utm_medium === null && value_Glid === null && canal_traf === null) {
            setCanal_trafico(organico);
        }

        if (value_promo !== null) {
            setQueu_promo(value_promo);
            getPromocion(value_promo)
        }

        if (value_formId !== null && value_formId !== "") {
            setReferencia_producto(referencia_productoC + "*" + value_formId);
        }
    }

    async function getPromocion(promo){
        console.log("configPromocion:", promo)
        if(promo !== "" && promo !== undefined){
            let url_servicio_web = urlServicioWeb
            const configPromocion = {
                method: 'POST',
                url: url_servicio_web + "getPromociones",
                data: {
                    "fc_nombre": promo
                },
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json"
                },
            };
            let response = await axios(configPromocion)
            if(response.data?.length>0){
                setDataPromocion(response.data[0])
                setIdProducto(response.data[0].fi_id_cola)
            } else {
                window.location = "https://www.claro.com.co/empresas/redirect"
            }
            console.log("configPromocion:", response)
        }
    }

    const onSubmitForm = data => {
        data.preventDefault();
        setDisabledContinua(true);

        window.grecaptcha.ready( () => {
            window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
              //submitData(token);
              console.info("Token response:"+ token);
              console.log("onSubmitForm idPlan:", idPlan, resumen_plan)
              let errors = {}
              // if (!ciudad || ciudad === '-1') {
              //     errors = {
              //         ciudad: {
              //             message: 'Selecciona la ciudad para el servicio.'
              //         }
              //     }
              // }
      
              // if (!idProducto || idProducto === '-1') {
              //     if (localStorage?.getItem('hide_product_promo') !== "true") {
              //         console.log("idProducto", idProducto, localStorage?.getItem('hide_product_promo'))
              //         errors = {
              //             ...errors,
              //             producto: {
              //                 message: 'Selecciona el tipo de documento'
              //             }
              //         }
              //     }
              // }
      
              if (!nombres) {
                  errors = {
                      ...errors,
                      nombres: {
                          message: 'Ingresa tu nombre'
                      }
                  }
              }
              if (!numDocumento) {
                  errors = {
                      ...errors,
                      numDocumento: {
                          message: 'Ingresa tu número de documento'
                      }
                  }
              } else {
                  if (numDocumento.length < 8) {
                      errors = {
                          ...errors,
                          numDocumento: {
                              message: 'Ingresa 8 dígitos para documento.'
                          }
                      }
                  }
              }
              if (!idDocumento || idDocumento === '-1' ) {
                  errors = {
                      ...errors,
                      idDocumento: {
                          message: 'Seleccione el tipo de documento'
                      }
                  }
              }
      
              if (!telefono) {
                  errors = {
                      ...errors,
                      telefono: {
                          message: 'Ingresa tu número de telefono para continuar'
                      }
                  }
              } else {
                  if (telefono.length < 10) {
                      errors = {
                          ...errors,
                          telefono: {
                              message: 'Ingresa 10 dígitos para fijo o móvil.'
                          }
                      }
                  } else if (!telefono.match(/^3|^60/)) {
                      errors = {
                          ...errors,
                          telefono: {
                              message: 'El móvil ingresado debe empezar en 3 o para teléfono fijo en 60 + Indicativo + Número de teléfono, ejemplo: 6017500500'
                          }
                      }
                  }
              }
      
              if (!autorizacion) {
                  errors = {
                      ...errors,
                      autorizacion: {
                          message: 'Acepta el tratamiento de datos para continuar.'
                      }
                  }
              }
              console.log("errors::::::", errors)
              setErrors(errors)
              if (Object.keys(errors).length === 0) {
      
                  procesoSolicitud()
      
              } else {
                  setDisabledContinua(false)
              }
            });
        });

/*
        setDisabledContinua(true)
        console.log("onSubmitForm idPlan:", idPlan, resumen_plan)
        let errors = {}
        // if (!ciudad || ciudad === '-1') {
        //     errors = {
        //         ciudad: {
        //             message: 'Selecciona la ciudad para el servicio.'
        //         }
        //     }
        // }

        // if (!idProducto || idProducto === '-1') {
        //     if (localStorage?.getItem('hide_product_promo') !== "true") {
        //         console.log("idProducto", idProducto, localStorage?.getItem('hide_product_promo'))
        //         errors = {
        //             ...errors,
        //             producto: {
        //                 message: 'Selecciona el tipo de documento'
        //             }
        //         }
        //     }
        // }

        if (!nombres) {
            errors = {
                ...errors,
                nombres: {
                    message: 'Ingresa tu nombre'
                }
            }
        }
        if (!numDocumento) {
            errors = {
                ...errors,
                numDocumento: {
                    message: 'Ingresa tu número de documento'
                }
            }
        } else {
            if (numDocumento.length < 8) {
                errors = {
                    ...errors,
                    numDocumento: {
                        message: 'Ingresa 8 dígitos para documento.'
                    }
                }
            }
        }
        if (!idDocumento || idDocumento === '-1' ) {
            errors = {
                ...errors,
                idDocumento: {
                    message: 'Seleccione el tipo de documento'
                }
            }
        }

        if (!telefono) {
            errors = {
                ...errors,
                telefono: {
                    message: 'Ingresa tu número de telefono para continuar'
                }
            }
        } else {
            if (telefono.length < 10) {
                errors = {
                    ...errors,
                    telefono: {
                        message: 'Ingresa 10 dígitos para fijo o móvil.'
                    }
                }
            } else if (!telefono.match(/^3|^60/)) {
                errors = {
                    ...errors,
                    telefono: {
                        message: 'El móvil ingresado debe empezar en 3 o para teléfono fijo en 60 + Indicativo + Número de teléfono, ejemplo: 6017500500'
                    }
                }
            }
        }

        if (!autorizacion) {
            errors = {
                ...errors,
                autorizacion: {
                    message: 'Acepta el tratamiento de datos para continuar.'
                }
            }
        }
        console.log("errors::::::", errors)
        setErrors(errors)
        if (Object.keys(errors).length === 0) {

            procesoSolicitud()

        } else {
            setDisabledContinua(false)
        }
*/        
    }

    async function procesoSolicitud() {
        let url_servicio_web = urlServicioWeb
        console.log("procesoSolicitud: resumen_plan", resumen_plan, "idFormulario", idFormulario)
        const configValidaI = {
            method: 'POST',
            url: url_servicio_web + 'validarIntentosTelefono',
            data: { fc_num_tel: telefono },
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            }
        }

        let response = await axios(configValidaI)
        console.log("response- validarIntentosTelefono------------------------->", idFormulario, resumen_plan, response);
        if (response.status === 200 && response?.data?.autorizar) {
            
            const dataEmp = {
                'ciudad': ciudadName,
                'idCiudad': ciudad,
                'optin': autorizacion ? 1 : 0,
                'producto': Array.isArray(dataProducto) ? dataProducto.find(p => p.fi_id_producto.toString() === idProducto).fc_descripcion : dataProducto.fc_nombre,
                "idProveedor": 1,
                "idSolicitud": 0,
                "nit": "",
                "razon_social": "",
                "service_url": "NA",
                apellidos,
                canal_trafico,
                cedula,
                "email": idDocumento.split("|")[0]+numDocumento,
                extension,
                glid,
                idFormulario: idFormulario,
                idProducto,
                nombres,
                queu_promo,
                referencia_producto,
                resumen_plan: resumen_plan,
                telefono,
                tipo_telefono,
                utm_campaign,
                utm_medium,
                utm_source,
            }

            console.log("dataEMP", dataEmp)

            const configSolicitud = {
                method: 'POST',
                url: url_servicio_web + 'procesoSolicitud',
                data: dataEmp,
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json"
                }
            }
            let response = await axios(configSolicitud)
            console.log("response- procesoSolicitud------------------------->", response);
            if (response.status === 200 && response?.data > 0) {
                setIdSolicitud(response.data)
                if (value_promo !== undefined && value_promo !== null) {
                    setMensajeSolicitud(value_promo)
                }
                else if (idProducto !== "-1" && idProducto !== null) {
                    setMensajeSolicitud(idProducto)
                }
                else if (idProducto !== "" && idProducto !== null) {
                    setMensajeSolicitud(idProducto)
                }
                else if (idFormulario !== undefined && idFormulario !== null) {
                    setMensajeSolicitud(idFormulario)
                }
                setSuccess(true)

            } else {
                setDisabledContinua(false)
            }
        } else {
            setDisabledContinua(false)
            if (!response.data.autorizar) {
                let errors = {
                    telefono: {
                        message: 'No se pudo validar el telefono'
                    }
                }
                if (response.data.mensaje) {
                    errors = {
                        telefono: {
                            message: response.data.mensaje
                        }
                    }
                }
                setErrors(errors)

            }
        }



    }

    const setNumberValid = value => {
        if (isNaN(value)) {
            return;
        }

        setTelefono(value)

        if (value.startsWith("60")) {
            setTipo_telefono(1)
        } else if (value.startsWith("3")) {
            setTipo_telefono(2)
        }
    }
    const setNumberValidDocument = value => {
        if (/^[a-zA-Z0-9]+$/.test(value) !== true && value.length > 0) {
            return;
        }
        setNumDocumento(value)
    }

    const producto = Array.isArray(dataPromocion) ? dataPromocion.find(p => p.fi_id_cola === idProducto) : dataPromocion
    console.log("dataPromocion::::::", idProducto, dataPromocion, producto)
    const imagen = idProducto !== '-1' ? producto.fc_imagen.split('.') : ''
    const ruta = idProducto !== '-1' && ruta_imagen ? ruta_imagen.replace('%ID_PRODUCTO%', idProducto) : ''
    const newRuta = idProducto !== '-1' ? `${ruta}${imagen[0]}` : ''

    const imagen_mv = idProducto !== '-1' ? producto?.fc_imagen_movil ? producto?.fc_imagen_movil.split('.') : '' : ''
    const ruta_mv = idProducto !== '-1' && ruta_imagen ? ruta_imagen.replace('%ID_PRODUCTO%', idProducto) : ''
    const newRuta_mv = idProducto !== '-1' ? `${ruta_mv}${imagen_mv[0]}` : ''

    useEffect(() => {
        getValuesDefault();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        getCiudades();
        getConfiguracion();
        getValuesURL();
        // getPromocion();
        // getPlan();
        // getInfoPlan();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const loadScriptByURL = (id, url, callback) => {
          const isScriptExist = document.getElementById(id);
    
          if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
              if (callback) callback();
            };
            document.body.appendChild(script);
          }
          if (isScriptExist && callback) callback();
        }
    
        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
          console.log("Script loaded!");
        });
    
      }, []);

    // console.log("dataPlan EMPRESAS:", dataPlan)
    return (
        <section className="c13Wrap">
            {
                idProducto === '-1' ?
                    <picture className="c13Background">
                        <source media="(max-width: 640px)" data-srcset={`${dataConfiguracion.imagen_MOVIL}.webp`} srcSet={`${dataConfiguracion.imagen_MOVIL}.webp`} type="image/webp" />
                        <source media="(max-width: 640px)" data-srcset={`${dataConfiguracion.imagen_MOVIL}.${dataConfiguracion.extension_IMAGEN_MOVIL}`} srcSet={`${dataConfiguracion.imagen_MOVIL}.${dataConfiguracion.extension_IMAGEN_MOVIL}`} type={`image/${dataConfiguracion.extension_IMAGEN_MOVIL}`} />
                        <source media="(min-width: 640px)" data-srcset={`${dataConfiguracion.imagen_DESKTOP}.webp`} srcSet={`${dataConfiguracion.imagen_DESKTOP}.webp`} type="image/webp" />
                        <source media="(min-width: 640px)" data-srcset={`${dataConfiguracion.imagen_DESKTOP}.${dataConfiguracion.extension_IMAGEN_DESKTOP}`} srcSet={`${dataConfiguracion.imagen_DESKTOP}.${dataConfiguracion.extension_IMAGEN_DESKTOP}`} type={`image/${dataConfiguracion.extension_IMAGEN_DESKTOP}`} />
                        <img className="lazyload" data-src={`${dataConfiguracion.imagen_DESKTOP}.${dataConfiguracion.extension_IMAGEN_DESKTOP}`} src={`${dataConfiguracion.imagen_DESKTOP}.${dataConfiguracion.extension_IMAGEN_DESKTOP}`} alt="Texto Imagen" width="1700" height="690" />
                    </picture>
                    :
                    <picture className="c13Background">
                        {
                            imagen_mv &&
                            <source media="(max-width: 640px)" data-srcset={`${newRuta_mv}.${imagen_mv[1]}`} srcSet={`${newRuta_mv}.${imagen_mv[1]}`} type={`image/${imagen_mv[1]}`} />
                        }

                        <source media="(min-width: 640px)" data-srcset={`${newRuta}.${imagen[1]}`} srcSet={`${newRuta}.${imagen[1]}`} type={`image/${imagen[1]}`} />
                        <img className="lazyload" data-src={`${newRuta}.${imagen[1]}`} src={`${newRuta}.${imagen[1]}`} alt={`${producto?.fc_descripcion}`} width="1700" height="690" />
                    </picture>
            }


            <div className="container">

                <div className={`c13 ${dataConfiguracion.titulo_DEBAJO_LOGO ? '' : 'c13NoInfo'}`}>
                    <div className="c13Info">
                        {
                            dataConfiguracion?.imagen_LOGO &&
                            <picture className="c13InfoLogo">
                                <source data-srcset={`${dataConfiguracion.imagen_LOGO}.webp`} srcSet={`${dataConfiguracion.imagen_LOGO}.webp`} type="image/webp" />
                                <source data-srcset={`${dataConfiguracion.imagen_LOGO}.${dataConfiguracion.extension_IMAGEN_LOGO}`} srcSet={`${dataConfiguracion.imagen_LOGO}.${dataConfiguracion.extension_IMAGEN_LOGO}`} type={`image/${dataConfiguracion.extension_IMAGEN_LOGO}`} />
                                <img className="lazyloaded" data-src={`${dataConfiguracion.imagen_LOGO}.${dataConfiguracion.extension_IMAGEN_LOGO}`} alt="Logo Claro" width="200" height="75" src={`${dataConfiguracion.imagen_LOGO}.${dataConfiguracion.extension_IMAGEN_LOGO}`} />
                            </picture>
                        }
                        {
                            dataConfiguracion?.titulo_DEBAJO_LOGO &&
                            <Title
                                tag={TitleTag.H2}
                                // style={TitleStyle.H4}
                                className=''
                            >
                                {dataConfiguracion.titulo_DEBAJO_LOGO}
                            </Title>
                        }
                        <div className="c13InfoItems">
                            {
                                dataConfiguracion?.texto_BULLET1 &&
                                <div className="c13InfoItem">
                                    <i className="ico ico-check-circle"></i>
                                    <p>{dataConfiguracion.texto_BULLET1}</p>
                                </div>
                            }
                            {
                                dataConfiguracion?.texto_BULLET2 &&
                                <div className="c13InfoItem">
                                    <i className="ico ico-check-circle"></i>
                                    <p>{dataConfiguracion.texto_BULLET2}</p>
                                </div>
                            }
                            {
                                dataConfiguracion?.texto_BULLET3 &&
                                <div className="c13InfoItem">
                                    <i className="ico ico-check-circle"></i>
                                    <p>{dataConfiguracion.texto_BULLET3}</p>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        success ?
                            <C13PeopleOrgSuccess
                                ciudadName={ciudadName}
                                telefono={telefono}
                                idSolicitud={idSolicitud}
                                dataPlan={dataPlan}
                                Configuracion={dataConfiguracion}
                                Mensaje={mensajeSolicitud}
                                Producto={Array.isArray(dataProducto) ? dataProducto.find(p => p.fi_id_producto.toString() === idProducto) : dataProducto}
                                nombres={nombres}
                                idDocumento={idDocumento}
                                numDocumento={numDocumento}
                            />
                            :
                            <C13PeopleOrgForm
                                onSubmit={onSubmitForm}
                                errors={errors}
                                dataCiudades={dataCiudades}
                                ciudad={ciudad}
                                setCiudad={setCiudad}
                                setCiudadName={setCiudadName}
                                telefono={telefono}
                                nombres={nombres}
                                setNombres={setNombres}
                                autorizacion={autorizacion}
                                setAutorizacion={setAutorizacion}
                                setNumberValid={setNumberValid}
                                setNumberValidDocument={setNumberValidDocument}
                                setIdProducto={setIdProducto}
                                idProducto={idProducto}
                                idDocumento={idDocumento}
                                setIdDocumento={setIdDocumento}
                                numDocumento={numDocumento}
                                setNumDocumento={setNumDocumento}
                                Configuracion={dataConfiguracion}
                                dataProducto={dataProducto}
                                disabledContinua={disabledContinua}
                            />
                    }
                </div>
            </div>
        </section>
    )
}

export default C13PeopleOrg
